import { Injectable } from '@angular/core';
import {MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { Geolocation } from '@capacitor/geolocation';
import { ToastrService } from 'ngx-toastr';

import { environment } from '../../../environments/environment';

import { ModalCustomComponent } from '../../shared/modal-custom/modal-custom.component';

@Injectable({
   providedIn: 'root'
})
/* 
   @deprecated
*/
export class GPSService {
   position = new BehaviorSubject<{
      latitude: number;
      longitude: number;
      accuracy: number;
      altitudeAccuracy?: number;
      altitude?: number;
      speed?: number;
      heading?: number;
   }>(undefined);

   modalDefineGPS: MatDialogRef<ModalCustomComponent>;

   constructor(private modal: MatDialog, private toastr: ToastrService) { }

   getCurrentPosition(): void {
      Geolocation.getCurrentPosition()
         .then(c => {
            // console.log(c);
            this.position.next(c.coords);
         })
         .catch(err => { console.log(err); });
   }

   defineGPS() {
      return new Observable<boolean>(res => {
         Geolocation.getCurrentPosition().then(c => {
            this.position.next(c.coords);
            res.next(true);
            res.complete();
            this.modalDefineGPS = undefined;
         }).catch(err => {
            Geolocation.getCurrentPosition()
            if (!this.modalDefineGPS) {
               this.modalDefineGPS = this.modal.open(ModalCustomComponent, {
                  panelClass: 'mnf-modal-container',
                  width: '95vw',
                  maxWidth: '650px',
                  autoFocus: false,
                  maxHeight: '95vh',
               });

               // Al cerrar el modal reiniciar la página para verificar si se activó la geolocalización
               this.modalDefineGPS.afterClosed().subscribe(() => location.reload());

               this.modalDefineGPS.componentInstance.config = {
                  header: 'Activa tu ubicación',
                  img: 'https://static.monific.com/assets/assets-app/img/icon/img/geolocalization.svg',
                  title: '¡Importante!',
                  message: `<p class="fs-14">Requerimos tu ubicación por que en términos de la "LRITF", las ITF deberán requerir y
                           obtener de sus Clientes la geolocalización del dispositivo móvil  cuando el Cliente:<br>
                           1. Abra su cuenta.<br>
                           2. Celebre operaciones.<br><br>
                           ${environment.isMobile ? '' :
                        `Si necesitas ayuda, visita
                           <a href="https://centrodeayuda.monific.com/gu%C3%ADa-de-inversi%C3%B3n-en-monific"
                           target="_blank">
                        cómo activar geolocalización en tu navegador.</a></p>`}`,
                  buttonText: 'Entendido'
               };

               Geolocation.requestPermissions().then(r => {
                  this.updateLocation();
                  res.next(true);
                  res.complete();
               }).catch(e => {
                  res.next(false);
                  res.complete();
               });
            }

            if (err instanceof GeolocationPositionError) {
               switch (err.message) {
                  case 'User denied Geolocation':
                     this.toastr.warning('Por seguridad, para poder invertir en Monific antes debes activar la geolocalización de tu dispositivo');
                     break;
               }
            }
         });
      })
   }

   async gpsIsDefined() {
      await this.updateLocation();

      if (this.position.getValue()) {
         return true;
      } else {
         if (!this.modalDefineGPS) {
            this.modalDefineGPS = this.modal.open(ModalCustomComponent);
            this.modalDefineGPS.componentInstance.config = {
               img: 'https://static.monific.com/assets/assets-app/img/icon/img/geolocalization.svg',
               title: '¡Importante!',
               message: 'Por seguridad, para poder invertir en Monific antes debes activar la geolocalización de tu dispositivo.',
               buttonText: 'Entendido'
            };
            this.modalDefineGPS.afterClosed().subscribe(() => setTimeout(() => this.modalDefineGPS = undefined, 200));
         }
         this.updateLocation();

         return false;
      }
   }

   async updateLocation() {
      const a = await Geolocation.getCurrentPosition();
      if (a.coords) {
         this.position.next(a.coords);
      }
      return a;
   }
}
